import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"
import { COLORS } from "../../utilities/Constants"

// GE-46 : bandeau « Fiche incomplète » en tête de la fiche dépannage.
// `champs` = dep.champs_manquants du serializer ([{cle, libelle}]), calculé
// côté serveur sur la fiche ENREGISTRÉE (règle unique champs_manquants).
// Même gabarit que BandeauLectureSeule (others/FicheVerrou).
const BandeauFicheIncomplete = ({ champs }) => {
	if (!champs || champs.length === 0) return null
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: 10,
				padding: "12px 18px",
				marginBottom: 20,
				borderRadius: 12,
				backgroundColor: COLORS.warningLight,
				border: `1px solid ${COLORS.warning}`,
				color: COLORS.warning,
				fontSize: 14,
				fontWeight: 500,
			}}
		>
			<FontAwesomeIcon icon={faExclamationTriangle} />
			<span>
				Fiche incomplète : {champs.map((c) => c.libelle).join(", ")}
				<span style={{ color: COLORS.textMuted, fontWeight: 400 }}>
					{" "}
					— à compléter avant le contrôle avant facturation.
				</span>
			</span>
		</div>
	)
}

export default BandeauFicheIncomplete
